import { render, staticRenderFns } from "./partnerReview.vue?vue&type=template&id=732ec4c7&scoped=true&"
import script from "./partnerReview.vue?vue&type=script&lang=js&"
export * from "./partnerReview.vue?vue&type=script&lang=js&"
import style0 from "./partnerReview.vue?vue&type=style&index=0&id=732ec4c7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732ec4c7",
  null
  
)

export default component.exports